import { useTranslation } from 'react-i18next'
import React from 'react'

import Tag from './Tag'
import { COLORS } from '@btime/constants'

export const PUBLIC = 'public'
export const PRIVATE = 'private'

const AccessTag = ({ value }) => {
  const { t } = useTranslation()
  return <Tag label={t(value)} color={value === PUBLIC ? COLORS.darkGreen : COLORS.dark3} />
}
export default AccessTag
